import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MilestoneStatusStartedIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M6.679 1.122a1.715 1.715 0 0 1 2.642 0L14.104 6.9a1.726 1.726 0 0 1 0 2.2l-4.783 5.778a1.715 1.715 0 0 1-2.642 0L1.896 9.1a1.726 1.726 0 0 1 0-2.2zm1.706 2.006a.5.5 0 0 0-.77 0L3.845 7.68a.5.5 0 0 0 0 .638l3.77 4.553a.5.5 0 0 0 .77 0l3.77-4.553a.5.5 0 0 0 0-.638z"
				clipRule="evenodd"
				opacity=".3"
			></path>
			<path
				fill="currentColor"
				d="M8 .5c.512 0 .996.23 1.321.622l2.516 3.04-1.42 1.42-2.032-2.454A.5.5 0 0 0 8 2.946z"
			></path>
		</svg>
	),
)
